interface Props {
  message?: string
}

export function LoadingScreen({ message = 'Loading your system data…' }: Props) {
  return (
    <div className="loading-screen">
      <div className="spinner" aria-label="Loading" />
      <p>{message}</p>
    </div>
  )
}
